<template>
	<div class="boothStaff-wrapper mb-2" :style="cardStyle">
		<div class="boothStaff-card">
      <SponsorBadge
          v-if="boothStaff.userFlag"
          :text="boothStaff.userFlag.flag_name"
          :top="'0px'"
          :right="'0px'"
          :iconSize="10"
          :iconColor="'#ffffff'"
          :background="boothStaff.userFlag.flag_bg_color"
          :color="boothStaff.userFlag.flag_txt_color"
      />
			<Avatar
				v-if="boothStaff && boothStaff.user_logo"
				class="boothStaff-card__logo"
				:size="52"
				:avatar="boothStaff.user_logo"
			/>
			<div v-if="boothStaff" class="boothStaff-card__info">
				<div v-if="userName" class="boothStaff-card__title">
					{{ userName }}
				</div>
				<div v-if="userPosition" class="boothStaff-card__second-title">
					{{ userPosition }}
				</div>
				<div v-if="userSecondProfile" class="boothStaff-card__second-title">
					{{ userSecondProfile }}
				</div>
				<div v-if="userLocation" class="boothStaff-card__subtitle">
					<Icon type="pin" :size="16" color="var(--location-color)" />
					<span class="boothStaff-card__location-value">{{ userLocation }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'
import Icon from '@/components/Icon'
import SponsorBadge from '@/components/SponsorBadge.vue'

export default {
	name: 'BootStaffCard',
	components: {
		Avatar,
		Icon,
    SponsorBadge
	},
	data() {
		return {
			mailTo: false,
			address: null,
		}
	},
	computed: {
    cardStyle() {
      return {
        backgroundColor: this.backgroundColor,
        border: this.isBoothStaffList ? '1px solid #e2e2e2' : ''
      }
    },
		userName() {
			return this.boothStaff.user_name || this.boothStaff.visible_username
		},
		userSecondProfile() {
			return this.boothStaff.second_profile_row
		},
		userPosition() {
			return this.boothStaff.user_occupation || this.boothStaff.third_profile_row
		},
		userLocation() {
			return this.boothStaff.user_address || this.boothStaff.location_profile_row
		},
    isBoothStaffList(){
      return this.$route.name === 'exhibitor-staff'
    },
	},
	props: {
		boothStaff: {
			type: Object,
			default: () => ({}),
		},
		backgroundColor: {
			type: String,
			default: '',
		},
	},
}
</script>

<style lang="scss">
.boothStaff-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px;
	border-radius: 8px;
  position: relative;
	/*border: 1px solid #e2e2e2;*/
}

.boothStaff-card {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.boothStaff-card__logo {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 52px;
	height: 52px;
	border-radius: 8px;
}

.boothStaff-card__info {
	flex: 1;
	margin-left: 12px;

	.boothStaff-card__title {
		color: var(--username-category-title);
		margin-bottom: 4px;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
	}

	.boothStaff-card__second-title,
	.boothStaff-card__third-title {
		color: var(--company-position-large);
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
	}

	.boothStaff-card__subtitle {
		display: flex;
		align-items: flex-start;
		margin-top: 8px;

		svg {
			margin-right: 4px;
		}

		.boothStaff-card__location-value {
			font-size: 13px;
			font-weight: 500;
			color: var(--location-color);
		}
	}
}

.boothStaff-card__bookmark {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.boothStaff-card__employee-banner {
	position: absolute;
	width: 115px;
	max-height: 22px;
	top: -16px;
	right: -16px;
	background-color: #4f89d5;
	color: #ffffff;
	font-size: 12px;
	font-weight: 700;
	padding: 2px 12px;
	border-radius: 0 10px 0 0;
	white-space: nowrap;
	font-family: Montserrat, sans-serif;

	&::before {
		content: '';
		position: absolute;
		left: -8px;
		top: 0;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 22px 18px 0 8px;
		border-color: #4f89d5 transparent transparent transparent;
	}
}
</style>
